
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../../node_modules/core-js/modules/es.array.concat.js';
import '../../../../node_modules/core-js/modules/es.array.includes.js';
import '../../../../node_modules/core-js/modules/es.array.map.js';
import '../../../../node_modules/core-js/modules/es.string.includes.js';
import React__default, { useState, useLayoutEffect, useCallback } from 'react';
import useDebounceFn from '../../../../node_modules/ahooks/es/useDebounceFn/index.js';
import Result from '../../Result/Result.js';
import TableRow from './TableRow.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var Body = function Body(_ref) {
  var _ref$id = _ref.id,
    tableId = _ref$id === void 0 ? "table" : _ref$id,
    selectable = _ref.selectable,
    _ref$autohide = _ref.autohide,
    autohide = _ref$autohide === void 0 ? false : _ref$autohide,
    state = _ref.state,
    dispatch = _ref.dispatch,
    onRowClick = _ref.onRowClick,
    onHoveredRowChange = _ref.onHoveredRowChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var columns = state.columns,
    selected = state.selected,
    emptyState = state.emptyState;
  var selectedRowsIds = selected.map(function (entry) {
    return entry.id;
  });
  var _useState = useState([window.innerWidth, window.innerHeight]),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var _size = _slicedToArray(size, 2),
    windowWidth = _size[0],
    windowHeight = _size[1];

  // use debounce on window resize to reduce Cell re-renders
  var _useDebounceFn = useDebounceFn(function () {
      return updateSize();
    }, {
      wait: 300
    }),
    debouncedUpdateSize = _useDebounceFn.run;
  var updateSize = function updateSize() {
    return setSize([window.innerWidth, window.innerHeight]);
  };
  useLayoutEffect(function () {
    window.addEventListener("resize", debouncedUpdateSize);
    return function () {
      return window.removeEventListener("resize", debouncedUpdateSize);
    };
  }, []);
  var handleRowHover = useCallback(function (row) {
    if (disabled) return;
    onHoveredRowChange && onHoveredRowChange(row);
  }, [onHoveredRowChange, disabled]);
  return jsx("tbody", null, state.rows.length > 0 ? jsx(React__default.Fragment, null, state.rows.map(function (row) {
    var isSelected = selectedRowsIds.includes(row.id);
    return jsx(TableRow, {
      rowId: "".concat(tableId, "-entry-").concat(row.id, "-select"),
      key: "".concat(tableId, "-entry-").concat(row.id, "-select"),
      row: row,
      columns: columns,
      windowWidth: windowWidth,
      windowHeight: windowHeight,
      isSelected: isSelected,
      selectable: Boolean(selectable),
      autohide: autohide,
      dispatch: dispatch,
      onRowClick: onRowClick,
      onHoveredRowChange: handleRowHover,
      disabled: disabled
    });
  })) : jsx("tr", {
    className: "empty-state-container"
  }, jsx("td", null, jsx(Result, emptyState))));
};

export { Body as default };
//# sourceMappingURL=Body.js.map
